// import React, { useState, useEffect, useCallback } from "react";
// import Footer from "../Footer/Footer";
// import { getUsers } from "../Services/userService";
// import { ILedgerEntry,ILedgerResponse,IOutstanding,ILedgerParams } from "../Interfaces/ILedger"
// import { DataGrid, GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
// import {
//   Box,
//   Container,
//   Stack,
//   Typography,
//   Chip,
//   Card,
//   CardContent,
//   Divider,
//   Skeleton,
//   Pagination,
//   useMediaQuery,
//   useTheme,
//   Autocomplete,
//   TextField,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   SelectChangeEvent,
//   Button,
//   IconButton,
//   Tooltip,
//   Collapse,
//   Alert,
//   Paper,
// } from "@mui/material";
// import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
// import FilterListIcon            from "@mui/icons-material/FilterList";
// import ClearIcon                 from "@mui/icons-material/Clear";
// import TrendingUpIcon            from "@mui/icons-material/TrendingUp";
// import TrendingDownIcon          from "@mui/icons-material/TrendingDown";
// import AccountBalanceIcon        from "@mui/icons-material/AccountBalance";
// import {getLedger}               from "../Services/LedgerService";
// // ── Types ─────────────────────────────────────────────────────────────────────
// interface Customer {
//   id:   string;
//   name: string;
// }

// // interface LedgerEntry {
// //   id:           string;
// //   ledgerEntryId: string;
// //   entryType:    string;
// //   referenceId:  string;
// //   customerName: string;
// //   debitAmount:  number;
// //   creditAmount: number;
// //   description:  string;
// //   createdDate:  any;
// // }

// // interface Outstanding {
// //   totalDebit:  number;
// //   totalCredit: number;
// //   balance:     number;
// // }

// const ENTRY_TYPES = ["INVOICE", "RECEIPT", "CREDIT_NOTE", "DEBIT_NOTE"];

// const entryTypeColor = (type: string): any => {
//   switch (type) {
//     case "INVOICE":     return "primary";
//     case "RECEIPT":     return "success";
//     case "CREDIT_NOTE": return "warning";
//     case "DEBIT_NOTE":  return "error";
//     default:            return "default";
//   }
// };

// const formatCurrency = (amount: number) =>
//   `₹${Number(amount ?? 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`;

// const formatDate = (ts: any): string => {
//   if (!ts) return "—";
//   if (ts._seconds) return new Date(ts._seconds * 1000).toLocaleDateString("en-IN");
//   return new Date(ts).toLocaleDateString("en-IN");
// };
// // ── Outstanding Summary Cards ─────────────────────────────────────────────────
// const OutstandingSummary: React.FC<{ outstanding: IOutstanding; isMobile: boolean }> = ({
//   outstanding,
//   isMobile,
// }) => {
//   const isCredit = outstanding.balance < 0; // you owe customer

//   return (
//     <Stack
//       direction={{ xs: "column", sm: "row" }}
//       spacing={1.5}
//       mb={2}
//     >
//       {/* Total Debit */}
//       <Card variant="outlined" sx={{ flex: 1, borderColor: "primary.light", borderRadius: 2 }}>
//         <CardContent sx={{ p: isMobile ? 1.5 : 2, "&:last-child": { pb: isMobile ? 1.5 : 2 } }}>
//           <Stack direction="row" justifyContent="space-between" alignItems="center">
//             <Box>
//               <Typography variant="caption" color="text.secondary">Total Invoiced</Typography>
//               <Typography variant={isMobile ? "subtitle1" : "h6"} fontWeight={700} color="primary.main">
//                 {formatCurrency(outstanding.totalDebit)}
//               </Typography>
//             </Box>
//             <TrendingUpIcon color="primary" sx={{ fontSize: isMobile ? 28 : 36, opacity: 0.7 }} />
//           </Stack>
//         </CardContent>
//       </Card>

//       {/* Total Credit */}
//       <Card variant="outlined" sx={{ flex: 1, borderColor: "success.light", borderRadius: 2 }}>
//         <CardContent sx={{ p: isMobile ? 1.5 : 2, "&:last-child": { pb: isMobile ? 1.5 : 2 } }}>
//           <Stack direction="row" justifyContent="space-between" alignItems="center">
//             <Box>
//               <Typography variant="caption" color="text.secondary">Total Received</Typography>
//               <Typography variant={isMobile ? "subtitle1" : "h6"} fontWeight={700} color="success.main">
//                 {formatCurrency(outstanding.totalCredit)}
//               </Typography>
//             </Box>
//             <TrendingDownIcon color="success" sx={{ fontSize: isMobile ? 28 : 36, opacity: 0.7 }} />
//           </Stack>
//         </CardContent>
//       </Card>

//       {/* Outstanding Balance */}
//       <Card
//         variant="outlined"
//         sx={{
//           flex: 1,
//           borderRadius: 2,
//           borderColor: isCredit ? "success.light" : outstanding.balance === 0 ? "grey.300" : "error.light",
//           bgcolor:     isCredit ? "success.50"    : outstanding.balance === 0 ? "grey.50"   : "error.50",
//         }}
//       >
//         <CardContent sx={{ p: isMobile ? 1.5 : 2, "&:last-child": { pb: isMobile ? 1.5 : 2 } }}>
//           <Stack direction="row" justifyContent="space-between" alignItems="center">
//             <Box>
//               <Typography variant="caption" color="text.secondary">
//                 {isCredit ? "Advance / Overpaid" : "Outstanding Due"}
//               </Typography>
//               <Typography
//                 variant={isMobile ? "subtitle1" : "h6"}
//                 fontWeight={700}
//                 color={isCredit ? "success.main" : outstanding.balance === 0 ? "text.secondary" : "error.main"}
//               >
//                 {formatCurrency(Math.abs(outstanding.balance))}
//               </Typography>
//             </Box>
//             <AccountBalanceIcon
//               sx={{
//                 fontSize: isMobile ? 28 : 36,
//                 opacity: 0.7,
//                 color: isCredit ? "success.main" : outstanding.balance === 0 ? "text.disabled" : "error.main",
//               }}
//             />
//           </Stack>
//           {outstanding.balance === 0 && (
//             <Chip label="Fully Paid" size="small" color="success" variant="outlined" sx={{ mt: 0.5 }} />
//           )}
//         </CardContent>
//       </Card>
//     </Stack>
//   );
// };

// // ── Mobile Ledger Card ────────────────────────────────────────────────────────
// const LedgerCard: React.FC<{ entry: ILedgerEntry }> = ({ entry }) => (
//   <Card variant="outlined" sx={{ mb: 1.5, borderRadius: 2, "&:hover": { boxShadow: 2 } }}>
//     <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
//       <Stack direction="row" justifyContent="space-between" alignItems="flex-start" mb={1}>
//         <Box sx={{ flex: 1, mr: 1 }}>
//           <Typography variant="body2" fontWeight={600} noWrap>
//             {entry.description || entry.referenceId || "—"}
//           </Typography>
//           <Typography variant="caption" color="text.secondary">{formatDate(entry.createdDate)}</Typography>
//         </Box>
//         <Chip
//           label={entry.entryType?.replace("_", " ")}
//           size="small"
//           color={entryTypeColor(entry.entryType)}
//           variant="outlined"
//         />
//       </Stack>
//       <Divider sx={{ my: 1 }} />
//       <Stack direction="row" justifyContent="space-between">
//         <Box>
//           <Typography variant="caption" color="text.secondary">Debit (DR)</Typography>
//           <Typography variant="body2" fontWeight={600} color={entry.debitAmount > 0 ? "error.main" : "text.disabled"}>
//             {entry.debitAmount > 0 ? formatCurrency(entry.debitAmount) : "—"}
//           </Typography>
//         </Box>
//         <Box textAlign="center">
//           <Typography variant="caption" color="text.secondary">Ref</Typography>
//           <Typography variant="body2">{entry.referenceId || "—"}</Typography>
//         </Box>
//         <Box textAlign="right">
//           <Typography variant="caption" color="text.secondary">Credit (CR)</Typography>
//           <Typography variant="body2" fontWeight={600} color={entry.creditAmount > 0 ? "success.main" : "text.disabled"}>
//             {entry.creditAmount > 0 ? formatCurrency(entry.creditAmount) : "—"}
//           </Typography>
//         </Box>
//       </Stack>
//     </CardContent>
//   </Card>
// );

// // ── Mobile Skeleton ───────────────────────────────────────────────────────────
// const MobileSkeleton: React.FC = () => (
//   <>
//     {[1, 2, 3].map((i) => (
//       <Card key={i} variant="outlined" sx={{ mb: 1.5, borderRadius: 2 }}>
//         <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
//           <Stack direction="row" justifyContent="space-between" mb={1}>
//             <Skeleton width="55%" height={20} />
//             <Skeleton width={80} height={24} sx={{ borderRadius: 4 }} />
//           </Stack>
//           <Skeleton height={1} sx={{ my: 1 }} />
//           <Stack direction="row" justifyContent="space-between">
//             <Skeleton width="28%" height={36} />
//             <Skeleton width="28%" height={36} />
//             <Skeleton width="28%" height={36} />
//           </Stack>
//         </CardContent>
//       </Card>
//     ))}
//   </>
// );

// // ── Main Component ────────────────────────────────────────────────────────────
// const ViewLedger: React.FC = () => {
//   const theme    = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const isTablet = useMediaQuery(theme.breakpoints.down("md"));

//   const orgId = localStorage.getItem("orgId") ?? "";

//   // ── State ───────────────────────────────────────────────────────────────────
//   const [customers,      setCustomers]      = useState<Customer[]>([]);
//   const [selectedCustomer, setSelectedCustomer] = useState<Customer | null>(null);

//   const [ledger,       setLedger]       = useState<ILedgerEntry[]>([]);
//   const [outstanding,  setOutstanding]  = useState<IOutstanding | null>(null);
//   const [loading,      setLoading]      = useState(false);
//   const [totalRows,    setTotalRows]    = useState(0);
//   const [showFilters,  setShowFilters]  = useState(!isMobile);

//   // Filters
//   const [filterEntryType, setFilterEntryType] = useState("");
//   const [filterFromDate,  setFilterFromDate]  = useState("");
//   const [filterToDate,    setFilterToDate]    = useState("");

//   const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });

//   // ── Load customers on mount ───────────────────────────────────────────────
//   useEffect(() => {
//     const loadCustomers = async () => {
//       try {
//         const data = await getUsers(orgId, "customer");
//         const list: Customer[] = (data ?? []).map((c: any) => ({
//           id:   c.Id,
//           name: c?.customerName ??
//             (c?.companyName ||
//               [c?.firstName, c?.lastName].filter(Boolean).join(" ")),
//         }));
//         setCustomers(list);
//       } catch (err) {
//         console.error("Failed to load customers:", err);
//       }
//     };
//     if (orgId) loadCustomers();
//   }, [orgId]);

//   // ── Fetch ledger ──────────────────────────────────────────────────────────
//   const fetchLedger = useCallback(async () => {
//     if (!orgId) return;
//     try {
//       setLoading(true);
//       const data = await getLedger({
//         orgId,
//         customerId: selectedCustomer?.id || undefined,
//         entryType:  filterEntryType      || undefined,
//         fromDate:   filterFromDate       || undefined,
//         toDate:     filterToDate         || undefined,
//         page:       paginationModel.page + 1,
//         limit:      paginationModel.pageSize,
//       });

//       setLedger(data.ledger ?? []);
//       setOutstanding(data.outstanding ?? null);
//       setTotalRows(
//         data.pagination
//           ? (data.pagination.page - 1) * data.pagination.limit + data.pagination.returned
//           : (data.ledger ?? []).length
//       );
//     } catch (err) {
//       console.error("Failed to fetch ledger:", err);
//       setLedger([]);
//     } finally {
//       setLoading(false);
//     }
//   }, [orgId, selectedCustomer, filterEntryType, filterFromDate, filterToDate, paginationModel]);

//   useEffect(() => { fetchLedger(); }, [fetchLedger]);

//   // ── Handlers ──────────────────────────────────────────────────────────────
//   const handleCustomerChange = (_: any, value: Customer | null) => {
//     setSelectedCustomer(value);
//     setOutstanding(null);
//     setPaginationModel((p) => ({ ...p, page: 0 }));
//   };

//   const handleSelectChange =
//     (setter: (v: string) => void) => (e: SelectChangeEvent) => {
//       setter(e.target.value);
//       setPaginationModel((p) => ({ ...p, page: 0 }));
//     };

//   const handleDateChange =
//     (setter: (v: string) => void) => (e: React.ChangeEvent<HTMLInputElement>) => {
//       setter(e.target.value);
//       setPaginationModel((p) => ({ ...p, page: 0 }));
//     };

//   const clearFilters = () => {
//     setFilterEntryType("");
//     setFilterFromDate("");
//     setFilterToDate("");
//     setPaginationModel({ page: 0, pageSize: 10 });
//   };

//   const hasActiveFilters = !!(filterEntryType || filterFromDate || filterToDate);

//   // ── Desktop columns ───────────────────────────────────────────────────────
//   const columns: GridColDef[] = [
//     {
//       field: "createdDate",
//       headerName: "Date",
//       width: 110,
//       valueFormatter: (value: any) => formatDate(value),
//     },
//     {
//       field: "entryType",
//       headerName: "Type",
//       width: 140,
//       renderCell: (params: GridRenderCellParams) => (
//         <Chip
//           label={params.value?.replace("_", " ")}
//           size="small"
//           color={entryTypeColor(params.value)}
//           variant="outlined"
//         />
//       ),
//     },
//     { field: "referenceId",  headerName: "Reference ID",   flex: 1,   minWidth: 160 },
//     { field: "customerName", headerName: "Customer Name",  flex: 1,   minWidth: 160 },
//     { field: "description",  headerName: "Description",    flex: 1.5, minWidth: 200 },
//     {
//       field: "debitAmount",
//       headerName: "Debit (DR)",
//       width: 130,
//       type: "number",
//       renderCell: (params: GridRenderCellParams) =>
//         params.value > 0 ? (
//           <Typography variant="body2" fontWeight={600} color="error.main">
//             {formatCurrency(params.value)}
//           </Typography>
//         ) : (
//           <Typography variant="body2" color="text.disabled">—</Typography>
//         ),
//     },
//     {
//       field: "creditAmount",
//       headerName: "Credit (CR)",
//       width: 130,
//       type: "number",
//       renderCell: (params: GridRenderCellParams) =>
//         params.value > 0 ? (
//           <Typography variant="body2" fontWeight={600} color="success.main">
//             {formatCurrency(params.value)}
//           </Typography>
//         ) : (
//           <Typography variant="body2" color="text.disabled">—</Typography>
//         ),
//     },
//   ];

//   // ── Render ────────────────────────────────────────────────────────────────
//   return (
//     <>
//       <div className="page-location">
//         <span>Ledger &gt; Customer Ledger</span>
//       </div>

//       <Container maxWidth="lg" sx={{ px: { xs: 1, sm: 2, md: 3 }, py: 1 }}>

//         {/* ── Header ─────────────────────────────────────────────────────── */}
//         <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
//           <Stack direction="row" alignItems="center" spacing={1}>
//             <AccountBalanceWalletIcon color="primary" fontSize={isMobile ? "small" : "medium"} />
//             <Typography variant={isMobile ? "subtitle1" : "h6"} fontWeight={600}>
//               Customer Ledger
//               {totalRows > 0 && (
//                 <Typography component="span" variant="body2" color="text.secondary" ml={1}>
//                   ({totalRows} entries)
//                 </Typography>
//               )}
//             </Typography>
//           </Stack>

//           <Button
//             size="small"
//             startIcon={<FilterListIcon />}
//             variant={hasActiveFilters ? "contained" : "outlined"}
//             color={hasActiveFilters ? "primary" : "inherit"}
//             onClick={() => setShowFilters((v) => !v)}
//           >
//             {isMobile
//               ? `Filters${hasActiveFilters ? " ●" : ""}`
//               : showFilters ? "Hide Filters" : "Show Filters"}
//           </Button>
//         </Stack>

//         {/* ── Customer Search (always visible) ─────────────────────────── */}
//         <Paper
//           variant="outlined"
//           sx={{ p: isMobile ? 1.5 : 2, mb: 2, borderRadius: 2, bgcolor: "grey.50" }}
//         >
//           <Typography variant="caption" color="text.secondary" display="block" mb={1}>
//             Search by Customer
//           </Typography>
//           <Autocomplete
//             options={customers}
//             getOptionLabel={(o) => o.name}
//             value={selectedCustomer}
//             onChange={handleCustomerChange}
//             size="small"
//             renderInput={(params) => (
//               <TextField
//                 {...params}
//                 label="Select Customer"
//                 placeholder="Type to search..."
//                 variant="outlined"
//               />
//             )}
//             sx={{ maxWidth: { xs: "100%", sm: 380 } }}
//             isOptionEqualToValue={(o, v) => o.id === v.id}
//             clearOnEscape
//           />
//           {selectedCustomer && (
//             <Typography variant="caption" color="text.secondary" mt={0.5} display="block">
//               Showing ledger for: <strong>{selectedCustomer.name}</strong>
//             </Typography>
//           )}
//         </Paper>

//         {/* ── Outstanding Summary (only when customer selected) ─────────── */}
//         {outstanding && selectedCustomer && (
//           <OutstandingSummary outstanding={outstanding} isMobile={isMobile} />
//         )}

//         {/* ── Filters Panel ────────────────────────────────────────────── */}
//         <Collapse in={showFilters}>
//           <Box
//             mb={2}
//             p={isMobile ? 1.5 : 2}
//             sx={{
//               bgcolor: "grey.50",
//               borderRadius: 2,
//               border: "1px solid",
//               borderColor: "grey.200",
//             }}
//           >
//             <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} flexWrap="wrap" useFlexGap>

//               {/* Entry Type */}
//               <FormControl size="small" fullWidth={isMobile} sx={{ flex: { sm: "1 1 160px" } }}>
//                 <InputLabel>Entry Type</InputLabel>
//                 <Select
//                   value={filterEntryType}
//                   label="Entry Type"
//                   onChange={handleSelectChange(setFilterEntryType)}
//                 >
//                   <MenuItem value="">All</MenuItem>
//                   {ENTRY_TYPES.map((t) => (
//                     <MenuItem key={t} value={t}>{t.replace("_", " ")}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>

//               {/* From Date */}
//               <TextField
//                 label="From Date"
//                 type="date"
//                 size="small"
//                 value={filterFromDate}
//                 onChange={handleDateChange(setFilterFromDate)}
//                 InputLabelProps={{ shrink: true }}
//                 fullWidth={isMobile}
//                 sx={{ flex: { sm: "1 1 150px" } }}
//               />

//               {/* To Date */}
//               <TextField
//                 label="To Date"
//                 type="date"
//                 size="small"
//                 value={filterToDate}
//                 onChange={handleDateChange(setFilterToDate)}
//                 InputLabelProps={{ shrink: true }}
//                 fullWidth={isMobile}
//                 sx={{ flex: { sm: "1 1 150px" } }}
//               />

//               {hasActiveFilters && (
//                 <Tooltip title="Clear filters">
//                   <IconButton
//                     onClick={clearFilters}
//                     size="small"
//                     color="error"
//                     sx={{ alignSelf: { xs: "flex-end", sm: "center" } }}
//                   >
//                     <ClearIcon />
//                   </IconButton>
//                 </Tooltip>
//               )}
//             </Stack>

//             {/* Active chips */}
//             {hasActiveFilters && (
//               <Stack direction="row" spacing={0.5} mt={1.5} flexWrap="wrap" useFlexGap>
//                 <Typography variant="caption" color="text.secondary" sx={{ alignSelf: "center" }}>Active:</Typography>
//                 {filterEntryType && <Chip label={filterEntryType.replace("_", " ")} size="small" onDelete={() => setFilterEntryType("")} />}
//                 {filterFromDate  && <Chip label={`From: ${filterFromDate}`}          size="small" onDelete={() => setFilterFromDate("")}  />}
//                 {filterToDate    && <Chip label={`To: ${filterToDate}`}              size="small" onDelete={() => setFilterToDate("")}    />}
//               </Stack>
//             )}
//           </Box>
//         </Collapse>

//         {/* ── Empty state when no search yet ───────────────────────────── */}
//         {!loading && ledger.length === 0 && !selectedCustomer && (
//           <Alert severity="info" sx={{ borderRadius: 2 }}>
//             Select a customer above to view their ledger, or leave it blank to see all entries.
//           </Alert>
//         )}

//         {/* ── Mobile: Card List ─────────────────────────────────────────── */}
//         {isMobile ? (
//           <>
//             {loading ? (
//               <MobileSkeleton />
//             ) : ledger.length === 0 ? (
//               <Box textAlign="center" py={6}>
//                 <AccountBalanceWalletIcon sx={{ fontSize: 48, color: "grey.300", mb: 1 }} />
//                 <Typography color="text.secondary">No ledger entries found</Typography>
//                 {hasActiveFilters && (
//                   <Button size="small" onClick={clearFilters} sx={{ mt: 1 }}>Clear filters</Button>
//                 )}
//               </Box>
//             ) : (
//               <>
//                 {ledger.map((entry) => (
//                   <LedgerCard key={entry.id} entry={entry} />
//                 ))}
//                 <Stack alignItems="center" spacing={1} mt={2} mb={1}>
//                   <Pagination
//                     count={Math.ceil(totalRows / paginationModel.pageSize)}
//                     page={paginationModel.page + 1}
//                     onChange={(_, p) => setPaginationModel((prev) => ({ ...prev, page: p - 1 }))}
//                     color="primary"
//                     size="small"
//                     siblingCount={1}
//                   />
//                   <Typography variant="caption" color="text.secondary">
//                     Showing {ledger.length} of {totalRows} entries
//                   </Typography>
//                 </Stack>
//               </>
//             )}
//           </>
//         ) : (
//           /* ── Desktop / Tablet: DataGrid ─────────────────────────────── */
//           <DataGrid
//             rows={ledger}
//             columns={columns}
//             getRowId={(row) => row.id ?? row.ledgerEntryId}
//             loading={loading}
//             pagination
//             paginationMode="server"
//             rowCount={totalRows}
//             paginationModel={paginationModel}
//             onPaginationModelChange={setPaginationModel}
//             pageSizeOptions={[10, 25, 50]}
//             autoHeight
//             disableRowSelectionOnClick
//             sx={{
//               borderRadius: 2,
//               "& .MuiDataGrid-columnHeaders": { bgcolor: "grey.50", fontWeight: 600 },
//               // Hide description on tablet to save space
//               ...(isTablet && {
//                 "& .MuiDataGrid-cell[data-field='description']":         { display: "none" },
//                 "& .MuiDataGrid-columnHeader[data-field='description']": { display: "none" },
//               }),
//             }}
//           />
//         )}
//       </Container>

//       <Box sx={{ width: "100%", mt: isMobile ? 4 : 10 }}>
//         <Footer />
//       </Box>
//     </>
//   );
// };

// export default ViewLedger;


import React, { useState, useEffect, useCallback } from "react";
import Footer        from "../Footer/Footer";
import { getUsers }  from "../Services/userService";
import { getLedger } from "../Services/LedgerService";
import {
  ILedgerEntry,
  IOutstanding,
} from "../Interfaces/ILedger";
import OutstandingSummary from "./OutstandingSummary"; // ← extracted component
import { DataGrid, GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Collapse,
  Container,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Pagination,
  Paper,
  Select,
  SelectChangeEvent,
  Skeleton,
  Stack,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ClearIcon                from "@mui/icons-material/Clear";
import FilterListIcon           from "@mui/icons-material/FilterList";
import ReceiptLongIcon          from "@mui/icons-material/ReceiptLong";
import PrintIcon                from "@mui/icons-material/Print";

// ─── Constants ────────────────────────────────────────────────────────────────

const ENTRY_TYPES = ["INVOICE", "RECEIPT", "CREDIT_NOTE", "DEBIT_NOTE"];

const entryTypeColor = (type: string): any => {
  switch (type) {
    case "INVOICE":     return "primary";
    case "RECEIPT":     return "success";
    case "CREDIT_NOTE": return "warning";
    case "DEBIT_NOTE":  return "error";
    default:            return "default";
  }
};

const entryTypeIcon = (type: string) => {
  switch (type) {
    case "INVOICE":     return "🧾";
    case "RECEIPT":     return "✅";
    case "CREDIT_NOTE": return "🔄";
    case "DEBIT_NOTE":  return "⚠️";
    default:            return "📄";
  }
};

const formatCurrency = (amount: number) =>
  `₹${Number(amount ?? 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`;

const formatDate = (ts: any): string => {
  if (!ts) return "—";
  if (ts._seconds) return new Date(ts._seconds * 1000).toLocaleDateString("en-IN");
  if (ts.seconds)  return new Date(ts.seconds  * 1000).toLocaleDateString("en-IN");
  return new Date(ts).toLocaleDateString("en-IN");
};

// ─── Types ────────────────────────────────────────────────────────────────────

interface Customer {
  id:   string;
  name: string;
}

// ─── Mobile Ledger Card ───────────────────────────────────────────────────────

const LedgerCard: React.FC<{ entry: ILedgerEntry; serialNo: number }> = ({
  entry,
  serialNo,
}) => {
  const isDebit = entry.debitAmount > 0;

  return (
    <Card
      variant="outlined"
      sx={{
        mb: 1.5,
        borderRadius: 2,
        borderLeft: "4px solid",
        borderLeftColor: isDebit ? "error.main" : "success.main",
        bgcolor: isDebit ? "rgba(211,47,47,0.03)" : "rgba(46,125,50,0.03)",
        "&:hover": { boxShadow: 2 },
        transition: "box-shadow 0.2s",
      }}
    >
      <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>

        {/* Row 1: Serial + Type + Date */}
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography
              variant="caption"
              sx={{
                bgcolor: "grey.100", color: "text.secondary",
                px: 0.8, py: 0.2, borderRadius: 1, fontWeight: 600,
              }}
            >
              #{serialNo}
            </Typography>
            <Chip
              label={`${entryTypeIcon(entry.entryType)} ${entry.entryType?.replace("_", " ")}`}
              size="small"
              color={entryTypeColor(entry.entryType)}
              variant="outlined"
            />
          </Stack>
          <Typography variant="caption" color="text.secondary">
            {formatDate(entry.createdDate)}
          </Typography>
        </Stack>

        {/* Row 2: Description */}
        <Typography variant="body2" sx={{ mb: 1, fontSize: 12 }}>
          {entry.description || entry.referenceId || "—"}
        </Typography>

        <Divider sx={{ my: 1 }} />

        {/* Row 3: Ref + DR + CR */}
        <Stack direction="row" justifyContent="space-between" alignItems="flex-end">
          <Box>
            <Typography variant="caption" color="text.secondary" display="block">Ref ID</Typography>
            <Typography variant="caption" fontWeight={500}>{entry.referenceId || "—"}</Typography>
          </Box>
          <Stack direction="row" spacing={2}>
            <Box textAlign="right">
              <Typography variant="caption" color="text.secondary" display="block">DR</Typography>
              <Typography
                variant="body2" fontWeight={700}
                color={entry.debitAmount > 0 ? "error.main" : "text.disabled"}
              >
                {entry.debitAmount > 0 ? formatCurrency(entry.debitAmount) : "—"}
              </Typography>
            </Box>
            <Box textAlign="right">
              <Typography variant="caption" color="text.secondary" display="block">CR</Typography>
              <Typography
                variant="body2" fontWeight={700}
                color={entry.creditAmount > 0 ? "success.main" : "text.disabled"}
              >
                {entry.creditAmount > 0 ? formatCurrency(entry.creditAmount) : "—"}
              </Typography>
            </Box>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};

// ─── Mobile Skeleton ──────────────────────────────────────────────────────────

const MobileSkeleton: React.FC = () => (
  <>
    {[1, 2, 3, 4].map((i) => (
      <Card key={i} variant="outlined" sx={{ mb: 1.5, borderRadius: 2 }}>
        <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
          <Stack direction="row" justifyContent="space-between" mb={1}>
            <Stack direction="row" spacing={1}>
              <Skeleton width={30}  height={22} sx={{ borderRadius: 1 }} />
              <Skeleton width={100} height={22} sx={{ borderRadius: 4 }} />
            </Stack>
            <Skeleton width={70} height={18} />
          </Stack>
          <Skeleton width="70%" height={16} sx={{ mb: 1 }} />
          <Skeleton height={1} sx={{ my: 1 }} />
          <Stack direction="row" justifyContent="space-between">
            <Skeleton width="30%" height={36} />
            <Skeleton width="25%" height={36} />
            <Skeleton width="25%" height={36} />
          </Stack>
        </CardContent>
      </Card>
    ))}
  </>
);

// ─── Main Component ───────────────────────────────────────────────────────────

const ViewLedger: React.FC = () => {
  const theme    = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  const orgId = localStorage.getItem("orgId") ?? "";

  // ── State ────────────────────────────────────────────────────────────────
  const [customers,        setCustomers]        = useState<Customer[]>([]);
  const [selectedCustomer, setSelectedCustomer] = useState<Customer | null>(null);
  const [ledger,           setLedger]           = useState<ILedgerEntry[]>([]);
  const [outstanding,      setOutstanding]      = useState<IOutstanding | null>(null);
  const [loading,          setLoading]          = useState(false);
  const [fetchError,       setFetchError]       = useState("");
  const [totalRows,        setTotalRows]        = useState(-1); // -1 = unknown
  const [showFilters,      setShowFilters]      = useState(!isMobile);

  const [filterEntryType, setFilterEntryType] = useState("");
  const [filterFromDate,  setFilterFromDate]  = useState("");
  const [filterToDate,    setFilterToDate]    = useState("");

  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });

  // ── Load customers ───────────────────────────────────────────────────────
  useEffect(() => {
    if (!orgId) return;
    const load = async () => {
      try {
        const data = await getUsers(orgId, "customer");
        setCustomers(
          (data ?? []).map((c: any) => ({
            id:   c.Id,
            name: c?.customerName
              ?? c?.companyName
              ?? [c?.firstName, c?.lastName].filter(Boolean).join(" ")
              ?? "Unknown",
          }))
        );
      } catch (err) {
        console.error("Failed to load customers:", err);
      }
    };
    load();
  }, [orgId]);

  // ── Fetch ledger ─────────────────────────────────────────────────────────
  const fetchLedger = useCallback(async () => {
    if (!orgId) return;
    setLoading(true);
    setFetchError("");
    try {
      const data = await getLedger({
        orgId,
        customerId: selectedCustomer?.id || undefined,
        entryType:  filterEntryType      || undefined,
        fromDate:   filterFromDate       || undefined,
        toDate:     filterToDate         || undefined,
        page:       paginationModel.page + 1,
        limit:      paginationModel.pageSize,
      });

      setLedger(data.ledger ?? []);
      setOutstanding(data.outstanding ?? null);

      // ── Correct totalRows (Error 2 fix — pagination.total now typed) ──
      const pg       = data.pagination;
      const returned = pg?.returned ?? (data.ledger ?? []).length;
      const limit    = pg?.limit    ?? paginationModel.pageSize;
      const page     = pg?.page     ?? paginationModel.page + 1;

      if (typeof pg?.total === "number" && pg.total >= 0) {
        // Backend now returns real total → use it directly
        setTotalRows(pg.total);
      } else {
        // Fallback: if full page returned, signal there may be more
        const knownMin = (page - 1) * limit + returned;
        const hasMore  = returned === limit;
        setTotalRows(hasMore ? knownMin + 1 : knownMin);
      }
    } catch (err: any) {
      console.error("Failed to fetch ledger:", err);
      setFetchError(err?.message || "Failed to load ledger. Please try again.");
      setLedger([]);
    } finally {
      setLoading(false);
    }
  }, [
    orgId, selectedCustomer,
    filterEntryType, filterFromDate, filterToDate,
    paginationModel,
  ]);

  useEffect(() => { fetchLedger(); }, [fetchLedger]);

  // ── Helpers ──────────────────────────────────────────────────────────────
  const resetPage = () => setPaginationModel((p) => ({ ...p, page: 0 }));

  const handleCustomerChange = (_: any, value: Customer | null) => {
    setSelectedCustomer(value);
    setOutstanding(null);
    setTotalRows(-1);
    resetPage();
  };

  const handleSelectChange =
    (setter: (v: string) => void) => (e: SelectChangeEvent) => {
      setter(e.target.value);
      resetPage();
    };

  const handleDateChange =
    (setter: (v: string) => void) =>
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setter(e.target.value);
      resetPage();
    };

  const clearFilters = () => {
    setFilterEntryType("");
    setFilterFromDate("");
    setFilterToDate("");
    resetPage();
  };

  const hasActiveFilters = !!(filterEntryType || filterFromDate || filterToDate);

  // Serial number offset for current page
  const serialOffset = paginationModel.page * paginationModel.pageSize;

  // Total pages for mobile pagination
  const totalPages = totalRows > 0
    ? Math.ceil(totalRows / paginationModel.pageSize)
    : paginationModel.page + 1;

  // ── Desktop columns ───────────────────────────────────────────────────
  const columns: GridColDef[] = [
    {
      field:      "__sno__",
      headerName: "S.No",
      width:      65,
      sortable:   false,
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        const idx = ledger.findIndex(
          (r) => (r.id ?? r.ledgerEntryId) === (params.row.id ?? params.row.ledgerEntryId)
        );
        return (
          <Typography variant="body2" color="text.secondary" fontWeight={500}>
            {serialOffset + idx + 1}
          </Typography>
        );
      },
    },
    {
      field:          "createdDate",
      headerName:     "Date",
      width:          105,
      valueFormatter: (value: any) => formatDate(value),
    },
    {
      field:      "entryType",
      headerName: "Type",
      width:      155,
      renderCell: (params: GridRenderCellParams) => (
        <Chip
          label={`${entryTypeIcon(params.value)} ${params.value?.replace("_", " ")}`}
          size="small"
          color={entryTypeColor(params.value)}
          variant="outlined"
          sx={{ fontWeight: 500 }}
        />
      ),
    },
    { field: "referenceId",  headerName: "Reference ID", flex: 1,   minWidth: 140 },
    {
      field:      "customerName",
      headerName: "Customer",
      flex:       1,
      minWidth:   150,
      // Hide if a customer is already selected — redundant
      ...(selectedCustomer ? { maxWidth: 0, minWidth: 0, width: 0 } : {}),
    },
    {
      field:      "description",
      headerName: "Description",
      flex:       1.5,
      minWidth:   180,
      renderCell: (params: GridRenderCellParams) => (
        <Tooltip title={params.value || ""} placement="top">
          <Typography variant="body2" noWrap sx={{ maxWidth: "100%" }}>
            {params.value || "—"}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field:       "debitAmount",
      headerName:  "Debit (DR)",
      width:       120,
      type:        "number",
      headerAlign: "right",
      align:       "right",
      renderCell: (params: GridRenderCellParams) =>
        params.value > 0 ? (
          <Typography variant="body2" fontWeight={700} color="error.main">
            {formatCurrency(params.value)}
          </Typography>
        ) : (
          <Typography variant="body2" color="text.disabled">—</Typography>
        ),
    },
    {
      field:       "creditAmount",
      headerName:  "Credit (CR)",
      width:       120,
      type:        "number",
      headerAlign: "right",
      align:       "right",
      renderCell: (params: GridRenderCellParams) =>
        params.value > 0 ? (
          <Typography variant="body2" fontWeight={700} color="success.main">
            {formatCurrency(params.value)}
          </Typography>
        ) : (
          <Typography variant="body2" color="text.disabled">—</Typography>
        ),
    },
  ];

  // Hide description + customer on tablet
  const visibleColumns = isTablet
    ? columns.filter((c) => !["description", "customerName"].includes(c.field))
    : columns;

  // ─── Render ──────────────────────────────────────────────────────────────
  return (
    <>
      <div className="page-location">
        <span>Ledger &gt; Customer Ledger</span>
      </div>

      <Container maxWidth="lg" sx={{ px: { xs: 1, sm: 2, md: 3 }, py: 1 }}>

        {/* ── Header ──────────────────────────────────────────────────── */}
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <AccountBalanceWalletIcon color="primary" fontSize={isMobile ? "small" : "medium"} />
            <Typography variant={isMobile ? "subtitle1" : "h6"} fontWeight={700}>
              Customer Ledger
              {totalRows > 0 && (
                <Typography component="span" variant="body2" color="text.secondary" ml={1}>
                  ({totalRows} {totalRows === 1 ? "entry" : "entries"})
                </Typography>
              )}
            </Typography>
          </Stack>

          <Stack direction="row" spacing={1}>
            <Tooltip title="Print Ledger">
              <IconButton size="small" onClick={() => window.print()}>
                <PrintIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Button
              size="small"
              startIcon={<FilterListIcon />}
              variant={hasActiveFilters ? "contained" : "outlined"}
              color={hasActiveFilters ? "primary" : "inherit"}
              onClick={() => setShowFilters((v) => !v)}
            >
              {isMobile
                ? `Filters${hasActiveFilters ? " ●" : ""}`
                : showFilters ? "Hide Filters" : "Show Filters"}
            </Button>
          </Stack>
        </Stack>

        {/* ── Error ───────────────────────────────────────────────────── */}
        {fetchError && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setFetchError("")}>
            {fetchError}
          </Alert>
        )}

        {/* ── Customer Selector ────────────────────────────────────────── */}
        <Paper variant="outlined" sx={{ p: 2, mb: 2, borderRadius: 2, bgcolor: "grey.50" }}>
          <Typography variant="caption" color="text.secondary" display="block" mb={1} fontWeight={500}>
            CUSTOMER ACCOUNT
          </Typography>
          <Autocomplete
            options={customers}
            getOptionLabel={(o) => o.name}
            value={selectedCustomer}
            onChange={handleCustomerChange}
            size="small"
            renderInput={(params) => (
              <TextField {...params} label="Select Customer" placeholder="Type to search..." />
            )}
            sx={{ maxWidth: { xs: "100%", sm: 420 } }}
            isOptionEqualToValue={(o, v) => o.id === v.id}
            clearOnEscape
          />
          {selectedCustomer && (
            <Typography variant="caption" color="primary.main" mt={0.5} display="block" fontWeight={500}>
              ▶ Showing ledger for: {selectedCustomer.name}
            </Typography>
          )}
        </Paper>

        {/* ── Outstanding Summary (Error 1 fix — no Grid divider prop) ─── */}
        {outstanding && selectedCustomer && (
          <OutstandingSummary
            outstanding={outstanding}
            customerName={selectedCustomer.name}
            isMobile={isMobile}
          />
        )}

        {/* ── Filters ──────────────────────────────────────────────────── */}
        <Collapse in={showFilters}>
          <Box
            mb={2} p={isMobile ? 1.5 : 2}
            sx={{ bgcolor: "grey.50", borderRadius: 2, border: "1px solid", borderColor: "grey.200" }}
          >
            {/* Fix 2: Grid layout so all controls are equal height/width */}
            <Grid container spacing={1.5} alignItems="flex-end">

              <Grid item xs={12} sm={6} md={3}>
                <FormControl size="small" fullWidth>
                  <InputLabel>Entry Type</InputLabel>
                  <Select
                    value={filterEntryType}
                    label="Entry Type"
                    onChange={handleSelectChange(setFilterEntryType)}
                  >
                    <MenuItem value="">All</MenuItem>
                    {ENTRY_TYPES.map((t) => (
                      <MenuItem key={t} value={t}>
                        {entryTypeIcon(t)} {t.replace("_", " ")}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  label="From Date"
                  type="date"
                  size="small"
                  fullWidth
                  value={filterFromDate}
                  onChange={handleDateChange(setFilterFromDate)}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ max: filterToDate || undefined }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  label="To Date"
                  type="date"
                  size="small"
                  fullWidth
                  value={filterToDate}
                  onChange={handleDateChange(setFilterToDate)}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ min: filterFromDate || undefined }}
                />
              </Grid>

              {hasActiveFilters && (
                <Grid item xs={12} sm={6} md={3}>
                  <Button
                    variant="outlined"
                    color="error"
                    size="small"
                    startIcon={<ClearIcon />}
                    onClick={clearFilters}
                    fullWidth
                  >
                    Clear Filters
                  </Button>
                </Grid>
              )}
            </Grid>

            {/* Active filter chips */}
            {hasActiveFilters && (
              <Stack direction="row" spacing={0.5} mt={1.5} flexWrap="wrap" useFlexGap>
                <Typography variant="caption" color="text.secondary" sx={{ alignSelf: "center" }}>
                  Active:
                </Typography>
                {filterEntryType && (
                  <Chip
                    label={filterEntryType.replace("_", " ")}
                    size="small"
                    color={entryTypeColor(filterEntryType)}
                    onDelete={() => { setFilterEntryType(""); resetPage(); }}
                  />
                )}
                {filterFromDate && (
                  <Chip
                    label={`From: ${filterFromDate}`}
                    size="small"
                    onDelete={() => { setFilterFromDate(""); resetPage(); }}
                  />
                )}
                {filterToDate && (
                  <Chip
                    label={`To: ${filterToDate}`}
                    size="small"
                    onDelete={() => { setFilterToDate(""); resetPage(); }}
                  />
                )}
              </Stack>
            )}
          </Box>
        </Collapse>

        {/* ── Empty state ──────────────────────────────────────────────── */}
        {!loading && ledger.length === 0 && !selectedCustomer && !fetchError && (
          <Alert severity="info" icon={<ReceiptLongIcon />} sx={{ borderRadius: 2 }}>
            Select a customer to view their account ledger, or leave blank to browse all entries.
          </Alert>
        )}

        {/* ── Mobile: Cards ────────────────────────────────────────────── */}
        {isMobile ? (
          <>
            {loading ? (
              <MobileSkeleton />
            ) : ledger.length === 0 ? (
              <Box textAlign="center" py={6}>
                <AccountBalanceWalletIcon sx={{ fontSize: 48, color: "grey.300", mb: 1 }} />
                <Typography color="text.secondary">No ledger entries found</Typography>
                {hasActiveFilters && (
                  <Button size="small" onClick={clearFilters} sx={{ mt: 1 }}>Clear filters</Button>
                )}
              </Box>
            ) : (
              <>
                {ledger.map((entry, idx) => (
                  <LedgerCard
                    key={entry.id ?? entry.ledgerEntryId}
                    entry={entry}
                    serialNo={serialOffset + idx + 1}
                  />
                ))}

                <Stack alignItems="center" spacing={1} mt={2} mb={1}>
                  <Pagination
                    count={totalPages}
                    page={paginationModel.page + 1}
                    onChange={(_, newPage) => {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                      setPaginationModel((prev) => ({ ...prev, page: newPage - 1 }));
                    }}
                    color="primary"
                    size="small"
                    siblingCount={1}
                    showFirstButton
                    showLastButton={totalRows > 0}
                  />
                  <Typography variant="caption" color="text.secondary">
                    Page {paginationModel.page + 1} of {totalPages}
                    {totalRows > 0 && ` · ${totalRows} total entries`}
                  </Typography>
                </Stack>
              </>
            )}
          </>
        ) : (
          /* ── Desktop / Tablet: DataGrid ─────────────────────────────── */
          <DataGrid
            rows={ledger}
            columns={visibleColumns}
            getRowId={(row) => row.id ?? row.ledgerEntryId}
            loading={loading}
            pagination
            paginationMode="server"
            rowCount={totalRows === -1 ? 0 : totalRows}
            paginationModel={paginationModel}
            onPaginationModelChange={(model) => {
              window.scrollTo({ top: 0, behavior: "smooth" });
              setPaginationModel(model);
            }}
            pageSizeOptions={[10, 25, 50, 100]}
            autoHeight
            disableRowSelectionOnClick
            density="compact"
            getRowClassName={(params) =>
              params.row.debitAmount  > 0 ? "row-debit"  :
              params.row.creditAmount > 0 ? "row-credit" : ""
            }
            slots={{
              noRowsOverlay: () => (
                <Box display="flex" flexDirection="column" alignItems="center"
                  justifyContent="center" height="100%" py={4}>
                  <AccountBalanceWalletIcon sx={{ fontSize: 48, color: "grey.300", mb: 1 }} />
                  <Typography color="text.secondary">No ledger entries found</Typography>
                  {hasActiveFilters && (
                    <Button size="small" onClick={clearFilters} sx={{ mt: 1 }}>Clear filters</Button>
                  )}
                </Box>
              ),
            }}
            sx={{
              borderRadius: 2,
              border: "1px solid",
              borderColor: "divider",
              "& .MuiDataGrid-columnHeaders": {
                bgcolor: "grey.100", fontWeight: 700, fontSize: 13,
                borderBottom: "2px solid", borderColor: "divider",
              },
              "& .row-debit":  { bgcolor: "rgba(211,47,47,0.04)",  "&:hover": { bgcolor: "rgba(211,47,47,0.08)"  } },
              "& .row-credit": { bgcolor: "rgba(46,125,50,0.04)",  "&:hover": { bgcolor: "rgba(46,125,50,0.08)"  } },
              "& .MuiDataGrid-footerContainer": { borderTop: "1px solid", borderColor: "divider", bgcolor: "grey.50" },
              "& .MuiDataGrid-cell": { fontSize: 13 },
            }}
          />
        )}
      </Container>

      <Box sx={{ width: "100%", mt: isMobile ? 4 : 10 }}>
        <Footer />
      </Box>
    </>
  );
};

export default ViewLedger;